import React from 'react';
import { LayersIcon, CpuIcon, NetworkIcon, RepeatIcon, ArrowRightIcon } from 'lucide-react';
export function BlueprintSection() {
  const pillars = [{
    icon: <LayersIcon className="w-8 h-8 text-cyan-400" data-id="element-1" />,
    title: 'THE GOLDEN STACK',
    description: "Forget the 500+ 'shiny' tools. You only need 3 pillars to build a $10k/month engine (The Brain, The Nervous System, and the Distribution Hub). I'll show you exactly how to connect them.",
    outcome: 'Most students complete this in 90 minutes and never look at another tool list again.'
  }, {
    icon: <CpuIcon className="w-8 h-8 text-cyan-400" data-id="element-2" />,
    title: 'THE INVISIBLE HYBRID FRAMEWORK',
    description: "The biggest fear in 2026 is 'AI Slop.' I'll show you how to use a 10% 'Human Checkpoint' to deliver content that sounds 100% human while maintaining 'Bot Overheads.'",
    outcome: 'Students report a 40% increase in engagement within the first week of implementation.'
  }, {
    icon: <NetworkIcon className="w-8 h-8 text-cyan-400" data-id="element-3" />,
    title: 'THE REVERSE OFFER',
    description: 'Stop groveling on Upwork. Use my proprietary outreach method that gets a 12% response rate by leading with value before you even say hello.',
    outcome: 'One student landed his first $2,500 client in 72 hours using this exact method.'
  }, {
    icon: <RepeatIcon className="w-8 h-8 text-cyan-400" data-id="element-4" />,
    title: 'THE SAAS-STYLE AGENCY',
    description: "Turn 'freelancing' into a recurring revenue machine using Stripe-automated workflows that pause themselves if a client doesn't pay.",
    outcome: 'Average time to first recurring payment: 14 days after setup.'
  }];
  return <section className="py-14 bg-dark-950 relative overflow-hidden" data-id="element-5">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[100px] pointer-events-none" data-id="element-6"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-7">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-8">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-9">
            Stop Thinking Outputs.
            <br data-id="element-10" />
            <span className="text-cyan-400 text-glow" data-id="element-11">
              Start Thinking Pipelines.
            </span>
          </h2>
          <p className="text-xl text-gray-400" data-id="element-12">
            This isn't about "tips or tricks." It's about the technical
            architecture of freedom. I'm handing you the keys to the Decoupled
            Content Method—where your time is finally, permanently disconnected
            from your production.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-13">
          {pillars.map((pillar, index) => <div key={index} className="bg-dark-900 border border-cyan-900/40 p-8 rounded-xl hover:border-cyan-500/50 transition-colors duration-300 group flex flex-col" data-id="element-14">
              <div className="w-16 h-16 bg-cyan-950/50 rounded-lg flex items-center justify-center mb-6 border border-cyan-900/50 group-hover:border-cyan-400/50 transition-colors" data-id="element-15">
                {pillar.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3 tracking-wide" data-id="element-16">
                {pillar.title}
              </h3>
              <p className="text-gray-400 leading-relaxed flex-grow" data-id="element-17">
                {pillar.description}
              </p>

              <div className="mt-6 pt-4 border-t border-cyan-900/30 flex items-start gap-2" data-id="element-18">
                <ArrowRightIcon className="w-4 h-4 text-cyan-400 shrink-0 mt-0.5" data-id="element-19" />
                <p className="text-sm italic text-cyan-400/80" data-id="element-20">
                  {pillar.outcome}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}